module.exports = __webpack_public_path__ + "img/41c-config-formularios-condicao.f74b4f45.png";